import { RpcError } from "grpc-web";
import { OmmuseClient } from "../proto/api_grpc_web_pb";
import { PostResendVerificationEmailRequest } from "../proto/api_pb";
import { PostResendVerificationEmailResponse } from "../proto/api_pb";
import { backOff } from "exponential-backoff";

export const resendVerificationEmail = async (
  token: string,
  userId: string,
  onResendEmailVerificationSuccess: () => void
): Promise<RpcError | PostResendVerificationEmailResponse | undefined> => {
  try {
    const ommuseClient = new OmmuseClient(process.env.REACT_APP_API_URL!);
    const request = new PostResendVerificationEmailRequest();
    request.setUserId(userId);

    const metadata = {
      Authorization: `${token}`,
      "Access-Control-Allow-Origin": "*",
    };

    return await backOff(
      () =>
        new Promise<PostResendVerificationEmailResponse | RpcError>(
          (resolve, reject) => {
            ommuseClient.postResendVerificationEmail(
              request,
              metadata,
              function (err, response) {
                if (err) {
                  reject(err);
                } else {
                  onResendEmailVerificationSuccess();
                  console.log("Verification email sent:", response);
                  resolve(response);
                }
              }
            );
          }
        ),
      {
        numOfAttempts: 3,
        jitter: "full",
      }
    );
  } catch (e) {
    console.error("Error sending verification email:", e);
  }
};
